import React from "../../__compat__/react/main.entry.mjs.mjs";
import { GenericNavigationItem } from "../GenericNavigation/index.mjs.mjs";
export const Tab = React.forwardRef((props, ref) => (React.createElement(GenericNavigationItem, { ...props, ref: ref })));
Tab.displayName = 'Tab';
//# sourceMappingURL=Tab.mjs.mjs.map